const DEFAULT_MESSAGE = 'Unknown error';

const hasMessage = (value: unknown): value is { message: string } =>
	value !== null && typeof value === 'object' && 'message' in value && typeof value.message === 'string';

export const getErrorMessage = (error: unknown): string => {
	if (typeof error === 'string') {
		return error;
	}

	if (hasMessage(error)) {
		return error.message;
	}

	return DEFAULT_MESSAGE;
};
